/** Dashboard widget: recent news across all researched companies. */

import React, { useEffect, useState } from "react";
import { apiClient } from "@/api/client";
import type { NewsItem } from "@/types";
import WidgetCard from "./WidgetCard";

const SENTIMENT_DOT: Record<string, string> = {
  positive: "bg-signal-teal",
  neutral: "bg-mist-400",
  negative: "bg-signal-rose",
};

export default function LatestNewsWidget(): React.ReactElement {
  const [items, setItems] = useState<NewsItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .get<NewsItem[]>("/news/recent", { params: { limit: 5 } })
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .catch(() => setError("Unable to load news"));
  }, []);

  return (
    <WidgetCard title="Latest news" isLoading={items === null && !error} error={error}>
      {items && items.length > 0 ? (
        <ul className="space-y-2">
          {items.map((item) => (
            <li key={item.id} className="flex items-start gap-2 text-sm">
              <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${SENTIMENT_DOT[item.sentiment]}`} />
              <span className="text-mist-200">{item.headline}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-mist-400">No recent news recorded yet.</p>
      )}
    </WidgetCard>
  );
}
